import {Checkmark, Close} from '@carbon/icons-react';
import React from 'react';

type Props = {
    passed: boolean;
    showText?: boolean;
}

export default function ComplianceIndicator(props: Props) {
    const {passed, showText} = props;
    return <div className="flex space-x-3">
        <div className={`w-5 h-5 text-white rounded-full flex justify-center items-center ${passed ? 'bg-blue-400' : 'bg-red-600'}`}>
            {passed ? <Checkmark data-testid='checkmark-icon'/> : <Close data-testid='close-icon'/>}
        </div>
        <span className="text-grey-500">{showText && (passed ? 'Pass' : 'Fail')}</span>
    </div>;
}